
import { debounce } from '../utils/debounce.js'
import { findEditContextInDOM, findEditContextOwnerElement } from '../edit-context.js'
import { SerialPromiseExecutor } from '../utils/serial-promise-executor.js'
import { themeDocumentToTheme } from '../form/theme.js'
import { getFirstNonEmptyString } from '../utils/lookup.js'
import { FormView } from '../form/view.js'
import { Form } from '../../model/form.js'
import ExperimentalFormLayout from './ae-experimental-form-layout.js'

const TABBED_FORM_LAYOUT = 'a34ed21c-7246-45ae-9f9c-9e6148ad92cf'
const EXPERIMENTAL_FORM_LAYOUT = '6c39f2cc-6059-42b2-8796-5c803899367c'
const EXPERIMENTAL_FORM_RENDERING_FEATURE = 'forms-rendering-experimental'
const EXPERIMENTAL_FORM_RENDERING_TAG = 'experimental-rendering'
const MIN_AUTOSAVE_DELAY = 60000
const SLOW_FORM_REVISION_RENDER_MS = 350

export default {
  /* tslint:disable */
  render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderError)?_c('pre',{staticClass:"ae-error"},[_vm._v(_vm._s(_vm.renderError))]):(_vm.renderedDocument && _vm.viewToUse && _vm.formToRender && _vm.shouldUseNativeFormRenderer)?_c('ae-experimental-form-layout',{key:_vm.renderedDocument.id + _vm.formToRender.id + _vm.formToRender.v,staticClass:"ae-form--layout ae-form--experimental-layout",class:_vm.formClasses,attrs:{"document":_vm.renderedDocument,"form":_vm.formToRender,"readonly":_vm.readonly,"root-section":_vm.rootSection,"theme":_vm.appliedTheme,"field-validation-errors":_vm.fieldValidationErrors,"params":_vm.params}}):(_vm.renderedDocument && _vm.viewToUse && _vm.formToRender)?_c('ae-layout',{key:_vm.renderedDocument.id + _vm.formToRender.id + _vm.formToRender.v,staticClass:"ae-form--layout",class:_vm.formClasses,attrs:{"watch-layout-revisions":_vm.watchLayoutRevisions,"layout-id":_vm.formLayoutId,"param-document":_vm.renderedDocument,"param-form":_vm.formToRender,"param-readonly":_vm.readonly,"param-root-section":_vm.rootSection,"param-field-conditions":_vm.fieldConditions,"param-field-validation-errors":_vm.fieldValidationErrors,"param-theme":_vm.appliedTheme,"param-view":_vm.viewToUse,"params":_vm.params}}):_vm._e()},
  staticRenderFns: [],
  /* tslint:enable */
  
  inject: ['getAeppicContext'],
  components: {
    'ae-experimental-form-layout': ExperimentalFormLayout,
  },
  props: {
    document: Object,
    documentId: String,
    layoutId: String,
    watch: {
      type: Boolean,
      default: true
    },
    watchLayoutRevisions: {
      type: Boolean,
      default: null
    },
    watchFormRevisions: {
      type: Boolean,
      default: true
    },
    autoSave: {
      type: Boolean,
      default: false
    },
    autoSaveAfter: {
      type: Number,
      // Keep typing uninterrupted; this is the inactivity fallback. A field
      // blur saves sooner when the user leaves the field.
      default: 60000
    },
    editContextOptOut: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    // A document (does not have to be stored in the model yet) usable
    // as a form description
    form: Object,
    theme: Object,
    view: [Object, String],
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isEditing() {
      return !!this.aeEditableDocument
    },
    isEditingExternally() {
      return this.isEditing && this.aeEditableDocument === this.documentToBindTo
    },
    renderedDocument() {
      return this.temporaryDocumentForForm || this.aeEditableDocument || this.documentToBindTo
    },
    renderedDocumentData() {
      const doc = this.renderedDocument
      return doc && doc.data
    },
    viewToUse() {
      if (!this.renderedDocument || !this.formToRender) {
        return
      }

      if (this.viewCache.view && this.viewCache.form === this.formToRender && this.viewCache.document && this.viewCache.optionsKey === this.formViewOptionsKey) {
        if (this.viewCache.document === this.renderedDocument) {
          return this.viewCache.view
        }

        if (!this.Aeppic.isEditableDocument(this.renderedDocument)) {
          if (this.viewCache.document.id === this.renderedDocument.id) {
            return this.viewCache.view
          }
        }
      }

      this.refreshViewCache()

      if (this.renderedDocument.id === this.viewCache.document?.id && this.viewCache.form === this.formToRender) {
        return this.viewCache.view
      }
    },
    rootSection() {
      return this.viewToUse?.rootSection
    },
    formViewOptions() {
      if (typeof this.view === 'string') {
        return {
          view: this.view,
        }
      }

      return this.view
    },
    formViewOptionsKey() {
      if (typeof this.view === 'string') {
        return `view:${this.view}`
      }

      if (!this.view) {
        return ''
      }

      try {
        return JSON.stringify(this.view)
      } catch (error) {
        return String(this.view)
      }
    },
    shouldUseNativeFormRenderer() {
      return this.nativeFormLayout || this.formLayoutId === TABBED_FORM_LAYOUT
    },
    formRevisionPreviewMessage() {
      if (this.formRevisionPreviewSlow) {
        return 'Formularvorschau pausiert, weil diese Revision langsam rendert.'
      }

      return 'Formularrevision verfügbar.'
    }
  },
  data() {
    return {
      Aeppic: this.getAeppicContext('ae-form'),
      documentToBindTo: null,
      fieldConditions: null,
      temporaryDocumentForForm: null,
      aeEditableDocument: null,
      deleted: false,
      formToRender: null,
      renderError: null,
      formLayoutId: null,
      nativeFormLayout: false,
      formClasses: [],
      viewCache: { updateIndex: 0, view: null, document: null, form: null, optionsKey: null },
      appliedTheme: null,
      fieldValidationErrors: {},
      fieldValidationResult: null,
      fieldValidationPending: false,
      formRevisionPreviewPending: false,
      formRevisionPreviewSlow: false,
      formRevisionPreviewDuration: 0,
    }
  },
  created() {
    this.$_loadDocumentExecutor = new SerialPromiseExecutor()

    this.$_loadDocument = async () => {
      if (this.isEditing && !this.readonly) {
        const editingDocumentId = this.aeEditableDocument.id
        const documentIsSame = this.documentId === editingDocumentId || (this.document && this.document.id === editingDocumentId)

        const newOrCurrentForm = this.form || this.formToRender

        if (newOrCurrentForm) {
          const formIsSame = this.aeEditableDocument.f.id === newOrCurrentForm.id &&
            this.aeEditableDocument.f.v === newOrCurrentForm.v
  
          if (documentIsSame && formIsSame) {
            return
          }
        }
      }

      this.flushFocusedControl()
      this.releaseCurrentEditableDocument()

      this.documentToBindTo = null
      this.aeEditableDocument = null

      this.stopWatchingDocument()
      this.stopWatchingDataChanges()

      if (this.document) {
        this.documentToBindTo = await this.document

        if (this.Aeppic.isEditableDocument(this.documentToBindTo)) {
          this.aeEditableDocument = this.documentToBindTo
          this.startWatchingDataChanges()
          this.trackEditableDocumentInEditContext('external-document-loaded')
        }
      } else if (this.documentId) {
        this.documentToBindTo = await this.Aeppic.get(this.documentId)
      } else {
        this.documentToBindTo = null
      }

      await this.loadFormToRender()

      this.startWatchingDocument()

      if (!this.isEditingExternally && !this.readonly) {
        await this.startEditing()
      }
    }

    if (this.autoSave) {
      this.debouncedSave = debounce(() => {
        this.save()
      }, this.getAutoSaveDelay())
    }

    this.renderTemporaryFormDebounced = debounce(() => {
      this.renderTemporaryForm()
    })

    this.debouncedValidateFields = debounce(() => {
      this.validateFields()
    }, 250)

    this._formDocumentsWatcher = null
    this._latestFormRevision = null
    this.temporaryDocumentForForm = null

    this.loadDocument()
  },
  mounted() {
    this.Aeppic.setContextRootElement(this.$el)
    this._aeFormMounted = true
    if (this.autoSave && this.$el) {
      this.$el.addEventListener('focusout', this.handleFocusOut, true)
    }

    // Find the nearest EditContext in the DOM hierarchy and re-track if needed
    if (!this.editContextOptOut) {
      this._resolvedEditContext = this._findEditContext()
      this._logEditContextResolution('mounted')

      // If we already have a tracked document but tracked in init before mount,
      // re-track now with the correct context
      if (this._resolvedEditContext && this.aeEditableDocument) {
        const trackOptions = {}

        this._logEditContextDebug('info', '[ae-form] tracking editable document in EditContext (mounted)', {
          owner: this._describeEditContextOwnerElement(this._findEditContextOwnerElement()),
          documentId: this.aeEditableDocument.id,
          autoSave: this.autoSave,
          trackOptions,
        })
        this._resolvedEditContext.track(this.aeEditableDocument, trackOptions)
      } else if (this._resolvedEditContext) {
        this._logEditContextDebug('warn', '[ae-form] EditContext found but no editable document to track yet (mounted)', {
          hasContext: !!this._resolvedEditContext,
          hasEditableDocument: !!this.aeEditableDocument,
          documentToBindTo: this.documentToBindTo?.id,
          documentId: this.documentId || this.document?.id,
          readonly: this.readonly,
        })
      }
    }
  },
  beforeDestroy() {
    if (this.$el) {
      this.$el.removeEventListener('focusout', this.handleFocusOut, true)
    }
    this.flushFocusedControl()
    this.releaseCurrentEditableDocument()
    this._resolvedEditContext = null

    this.cancelEditing()
    this.Aeppic.release()
  },
  watch: {
    watch() {
      this.stopWatchingDocument()
      this.startWatchingDocument()
    },
    document() {
      this.loadDocument()
    },
    documentId() {
      this.loadDocument()
    },
    readonly() {
      if (this.readonly) {
        this.cancelEditing()
      } else {
        this.startEditing()
      }
    },
    viewToUse: {
      handler() {
        this.refreshView()
      },
      deep: true
    },
    form: {
      handler() {
        this.loadDocument()
      },
      deep: true
    },
    renderedDocumentData: {
      handler() {
        this.refreshView()
        this.scheduleFieldValidation()
      },
      deep: true
    }
  },
  methods: {
    flushFocusedControl() {
      const activeElement = typeof document !== 'undefined' ? document.activeElement : null

      if (!activeElement || !this.$el || !this.$el.contains(activeElement)) {
        return
      }

      if (activeElement instanceof HTMLElement) {
        activeElement.blur()
      }
    },
    handleFocusOut(event) {
      if (!this.autoSave || !this._aeFormMounted || !this.$el) {
        return
      }

      const target = event?.target
      if (!target || typeof target.closest !== 'function') {
        return
      }

      // A field can contain several focusable controls (for example a
      // select/search popup). Do not save while focus moves within that field.
      const field = target.closest('.ae-form-field')
      const relatedTarget = event.relatedTarget
      if (field && relatedTarget && field.contains(relatedTarget)) {
        return
      }

      if (this._resolvedEditContext) {
        this._resolvedEditContext.saveOnFieldBlur()
      } else {
        this.save()
      }
    },
    getAutoSaveDelay() {
      return Math.max(this.autoSaveAfter || 0, MIN_AUTOSAVE_DELAY)
    },
    releaseCurrentEditableDocument() {
      if (!this.aeEditableDocument) {
        return
      }

      if (this._resolvedEditContext) {
        // The ancestor context owns the edit session. Releasing this form
        // view must not remove the document or resolve the session; another
        // form/dialog may render it before the owner saves or cancels.
        return
      } else if (this.autoSave) {
        this.save()
      }
    },
    _findEditContext() {
      if (this.$el && findEditContextInDOM) {
        return findEditContextInDOM(this.$el)
      }
      return null
    },
    _findEditContextOwnerElement() {
      return this.$el ? findEditContextOwnerElement(this.$el) : null
    },
    _describeEditContextOwnerElement(element) {
      if (!element) {
        return 'none'
      }

      const dataset = element.dataset || {}
      const name = dataset.aeEditContextName
        || dataset.aeLayoutId
        || dataset.aeDesignId
        || dataset.aeControlId
        || element.id
        || element.className
        || element.tagName

      return String(name)
    },
    _logEditContextResolution(reason) {
      if (this.editContextOptOut) {
        return
      }

      const ownerElement = this._findEditContextOwnerElement()
      const owner = this._describeEditContextOwnerElement(ownerElement)
      const documentId = this.aeEditableDocument?.id || this.documentToBindTo?.id || this.documentId || this.document?.id || 'unknown'

      if (this._resolvedEditContext) {
        this._logEditContextDebug('info', `[ae-form] EditContext found (${reason})`, {
          owner,
          documentId,
          autoSave: this.autoSave,
          element: ownerElement,
        })
      } else {
        this._logEditContextDebug('warn', `[ae-form] No EditContext found (${reason}); auto-save will use ae-form fallback`, {
          documentId,
          autoSave: this.autoSave,
          element: this.$el,
        })
      }
    },
    _logEditContextDebug(level, message, payload) {
      if (globalThis.__AE_EDIT_CONTEXT_DEBUG__) {
        console[level](message, payload)
      }
    },
    trackEditableDocumentInEditContext(reason) {
      if (this.editContextOptOut) {
        return
      }

      if (!this._resolvedEditContext || !this.aeEditableDocument) {
        this._logEditContextDebug('warn', `[ae-form] could not track editable document in EditContext (${reason})`, {
          hasContext: !!this._resolvedEditContext,
          hasEditableDocument: !!this.aeEditableDocument,
          documentToBindTo: this.documentToBindTo?.id,
          documentId: this.documentId || this.document?.id,
          readonly: this.readonly,
          isEditingExternally: this.isEditingExternally,
        })
        return
      }

      const trackOptions = {}

      this._logEditContextDebug('info', `[ae-form] tracking editable document in EditContext (${reason})`, {
        owner: this._describeEditContextOwnerElement(this._findEditContextOwnerElement()),
        documentId: this.aeEditableDocument.id,
        autoSave: this.autoSave,
        trackOptions,
      })

      this._resolvedEditContext.track(this.aeEditableDocument, trackOptions)
    },
    async refreshViewCache() {
      const viewCacheId = ++this.viewCache.updateIndex

      this.viewCache.view = null

      if (viewCacheId < this.viewCache.updateIndex) {
        return
      }

      if (!this.renderedDocument || !this.formToRender) {
        return
      }

      const newView = new FormView(this.renderedDocument, this.formToRender, this.formViewOptions)

      this.viewCache = {
        updateIndex: this.viewCache.updateIndex,
        view: newView,
        document: this.renderedDocument,
        form: this.formToRender,
        optionsKey: this.formViewOptionsKey,
      }
    },
    async loadDocument() {
      this.$_loadDocumentExecutor.runNext(async () => await this.$_loadDocument())
    },
    async loadFormToRender() {
      this.stopWatchingForFormDocumentsChanges()


      if (!this.documentToBindTo) {
        this.formLayoutId = null
        this.nativeFormLayout = false
        this.formToRender = null
        return
      }

      if (this.form) {
        this.formToRender = this.form.info ? this.form : this.Aeppic.buildTemporaryForm(this.form)
      } else {
        this.formToRender = await this.Aeppic.getFormForDocument(this.documentToBindTo)
      }

      this.startWatchingForFormDocumentsChanges(this.formToRender.id)

      const optionalExperimentalRendering = await this.applyExperimentalRenderingMethod()
      await this.applyTheme()

      const explicitLayout = getFirstNonEmptyString(this.layoutId, this.appliedTheme.form.layout)
      const featureLayout = optionalExperimentalRendering?.layoutId

      this.formLayoutId = getFirstNonEmptyString(explicitLayout, featureLayout) ?? TABBED_FORM_LAYOUT
      this.nativeFormLayout = !explicitLayout && optionalExperimentalRendering?.native === true
      this.formClasses = this.appliedTheme.form.classes

      this.refreshView()
      this.scheduleFieldValidation({ immediate: true })
    },

    startWatchingDocument() {
      if (!this.watch) {
        return
      }

      if (!this.documentToBindTo) {
        return
      }

      this.watcher = this.Aeppic.watch(this.documentToBindTo.id, onChange.bind(this))

      function onChange(changedDocument, reason) {
        if (reason.deletedHard) {
          this.documentToBindTo = null
          this.deleted = true
          return
        }

        if (!this.isEditingExternally) {
          this.documentToBindTo = changedDocument
        }

        this.handleChanges(changedDocument, reason)
      }
    },
    stopWatchingDocument() {
      if (this.watcher) {
        this.watcher.stop()
        this.watcher = null
      }
    },
    async startEditing() {
      if (this.isEditingExternally) {
        this.$emit('start-editing', this.aeEditableDocument)
      } else {
        if (!this.documentToBindTo) {
          return
        }

        if (this.readonly) {
          return
        }

        if (this.isEditing) {
          this.cancelEditing()
        }

        this.aeEditableDocument = await this.Aeppic.edit(this.documentToBindTo.id)
      }

      // Track in the nearest EditContext if available
      if (this._resolvedEditContext && this.aeEditableDocument) {
        const trackOptions = {}

        this._logEditContextResolution('startEditing')
        this._logEditContextDebug('info', '[ae-form] tracking editable document in EditContext (startEditing)', {
          owner: this._describeEditContextOwnerElement(this._findEditContextOwnerElement()),
          documentId: this.aeEditableDocument.id,
          autoSave: this.autoSave,
          trackOptions,
        })
        this._resolvedEditContext.track(this.aeEditableDocument, trackOptions)
      } else {
        this._logEditContextResolution('startEditing')
        if (this.autoSave) {
          this._logEditContextDebug('warn', '[ae-form] could not track editable document in EditContext (startEditing)', {
            hasContext: !!this._resolvedEditContext,
            hasEditableDocument: !!this.aeEditableDocument,
            documentToBindTo: this.documentToBindTo?.id,
            documentId: this.documentId || this.document?.id,
            readonly: this.readonly,
            isEditingExternally: this.isEditingExternally,
          })
        }
      }

      this.startWatchingDataChanges()
      this.scheduleFieldValidation({ immediate: true })
    },
    startWatchingDataChanges() {
      this.cancelWatchingEditData = this.$watch('aeEditableDocument.data', onDataChanged.bind(this), { deep: true })

      function onDataChanged() {
        if (this.aeEditableDocument) {
          if (this.isEditingExternally) {
            this.$emit('data-changed', this.aeEditableDocument)
          } else {
            this.Aeppic.commit(this.aeEditableDocument)
          }

          // When EditContext is active, it handles save timing.
          // Otherwise fall back to ae-form's own debouncedSave.
          // Note: _aeFormMounted is set in mounted() — before mount,
          // we don't know if an EditContext exists yet, so we defer.
          if (this.autoSave && this._aeFormMounted && !this._resolvedEditContext) {
            this.debouncedSave()
          }
        }
      }
    },
    stopWatchingDataChanges() {
      if (this.cancelWatchingEditData) {
        this.cancelWatchingEditData()
        this.cancelWatchingEditData = null
      }
    },
    startWatchingTemporaryDocumentForFormData() {
      this.stopWatchingTemporaryDocumentForFormData()

      this.cancelWatchingTemporaryDocumentForFormData = this.$watch('temporaryDocumentForForm.data', onDataChanged.bind(this), { deep: true })

      function onDataChanged() {
        if (this.temporaryDocumentForForm) {
          this.formToRender.recalculateData(this.temporaryDocumentForForm.data)
        }
      }
    },
    stopWatchingTemporaryDocumentForFormData() {
      if (this.cancelWatchingTemporaryDocumentForFormData) {
        this.cancelWatchingTemporaryDocumentForFormData()
        this.cancelWatchingTemporaryDocumentForFormData = null
      }
    },
    startWatchingForFormDocumentsChanges(formId) {
      this.stopWatchingForFormDocumentsChanges()

      if (!this.watchFormRevisions || !formId) {
        return
      }

      this._formDocumentsRevisionWatcher = this.Aeppic.watchRevisions(formId, (document) => {
        this._latestFormRevision = document

        if (this.formRevisionPreviewSlow) {
          this.formRevisionPreviewPending = true
          return
        }

        this.renderTemporaryFormDebounced()
      })

      this._formDocumentsWatcher = this.Aeppic.watch(formId, async (document) => {
        if (this._latestFormRevision) {
          this._latestFormRevision = null
          this.temporaryDocumentForForm = null
          this.formRevisionPreviewPending = false

          this.stopWatchingForFormDocumentsChanges()

          await this.loadFormToRender()
        }
      })
    },
    async renderTemporaryForm() {
      if (this._latestFormRevision) {
        this.formRevisionPreviewPending = false
        const started = this.now()
        const previousDocumentForExistingData = this.temporaryDocumentForForm || this.aeEditableDocument || this.documentToBindTo
        const previousFormForExistingData = this.formToRender || this.Aeppic.getDocumentForm(previousDocumentForExistingData)

        this.temporaryDocumentForForm = null
        this.formToRender = this.Aeppic.buildTemporaryForm(this._latestFormRevision)
        this.temporaryDocumentForForm = this.Aeppic.buildTemporaryEditableDocument(this.formToRender)

        this.copyDataFields(this.temporaryDocumentForForm.data, this.formToRender, previousDocumentForExistingData.data, previousFormForExistingData)
        this.startWatchingTemporaryDocumentForFormData()

        await this.waitForRenderedFrame()

        const duration = this.now() - started
        this.formRevisionPreviewDuration = duration

        if (duration > SLOW_FORM_REVISION_RENDER_MS) {
          this.formRevisionPreviewSlow = true
        }
      }
    },
    refreshPendingFormRevision() {
      this.renderTemporaryForm()
    },
    now() {
      if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        return performance.now()
      }

      return Date.now()
    },
    async waitForRenderedFrame() {
      await this.$nextTick()

      await new Promise((resolve) => {
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(resolve)
        } else {
          setTimeout(resolve, 0)
        }
      })
    },
    async applyExperimentalRenderingMethod() {
      if (!this.formToRender) {
        return
      }

      const featureEnabled = await this.Aeppic.Features.isEnabled(EXPERIMENTAL_FORM_RENDERING_FEATURE)
      const options = this.Aeppic.Features.getOptionsFor(EXPERIMENTAL_FORM_RENDERING_FEATURE) || {}
      const defaultRenderingMode = options.default === 'all' ? 'all' : 'none'
      const exceptions = Array.isArray(options.exceptions) ? options.exceptions : []
      const formIsException = exceptions.includes(this.formToRender.id)
      const taggedWithExperimentalRendering = this.formToRender.data.tags?.includes(EXPERIMENTAL_FORM_RENDERING_TAG)
      let renderExperimentally = defaultRenderingMode === 'all' || taggedWithExperimentalRendering

      if (formIsException) {
        renderExperimentally = defaultRenderingMode !== 'all'
      }

      if (featureEnabled && renderExperimentally) {
        const configuredLayout = getFirstNonEmptyString(options.layoutId)

        if (configuredLayout) {
          return {
            layoutId: configuredLayout,
            native: false,
          }
        }

        return {
          layoutId: EXPERIMENTAL_FORM_LAYOUT,
          native: true,
        }
      } else {
        return
      }
    },
    async applyTheme() {
      if (this.theme) {
        this.appliedTheme = this.theme
      } else {
        const themeDocument = await this.Aeppic.get(this.formToRender?.data.theme)
        this.appliedTheme = await themeDocumentToTheme(themeDocument)
      }

      // if (!this.theme.form.layout) {
      //   this.theme.form.layout = FORM_SECTION_LAYOUT
      // }
    },
    copyDataFields(targetData, targetForm: Form, sourceData, sourceForm: Form) {
      targetForm.copyFieldsFromDifferentForm(targetData, sourceData, sourceForm)
      targetForm.recalculateData(targetData)
    },
    stopWatchingForFormDocumentsChanges() {
      this.temporaryDocumentForForm = null
      this._latestFormRevision = null
      this.formRevisionPreviewPending = false

      if (this._formDocumentsRevisionWatcher) {
        this._formDocumentsRevisionWatcher.stop()
        this._formDocumentsRevisionWatcher = null
      }

      if (this._formDocumentsWatcher) {
        this._formDocumentsWatcher.stop()
        this._formDocumentsWatcher = null
      }

      this.stopWatchingTemporaryDocumentForFormData()
    },
    refreshView() {
      if (this.formToRender && this.renderedDocument) {
        this.fieldConditions = this.formToRender.evaluateConditions(this.renderedDocument.data)
      } else {
        this.fieldConditions = {}
      }

      this.viewToUse?.refresh(this.fieldConditions)
    },
    hasFieldValidationDeclarations() {
      if (!this.formToRender || typeof this.formToRender.getAllFieldValidations !== 'function') {
        return false
      }

      return this.formToRender.getAllFieldValidations().length > 0
    },
    scheduleFieldValidation(options) {
      options = options || {}

      if (!this.hasFieldValidationDeclarations()) {
        this.fieldValidationErrors = {}
        this.fieldValidationResult = null
        this.fieldValidationPending = false
        return
      }

      if (options.immediate) {
        this.validateFields()
      } else {
        this.debouncedValidateFields()
      }
    },
    async validateFields() {
      const target = this.renderedDocument

      if (!target || !this.hasFieldValidationDeclarations()) {
        this.fieldValidationErrors = {}
        this.fieldValidationResult = null
        this.fieldValidationPending = false
        return
      }

      const validationRunId = (this._fieldValidationRunId || 0) + 1
      this._fieldValidationRunId = validationRunId
      this.fieldValidationPending = true

      try {
        const result = await this.Aeppic.Validations.validateFields(target)

        if (validationRunId !== this._fieldValidationRunId) {
          return
        }

        this.fieldValidationResult = result
        this.fieldValidationErrors = this.createFieldValidationErrorMap(result)
      } catch (error) {
        if (validationRunId !== this._fieldValidationRunId) {
          return
        }

        console.warn('[ae-form] Could not run field validations', error)
        this.fieldValidationResult = null
        this.fieldValidationErrors = {}
      } finally {
        if (validationRunId === this._fieldValidationRunId) {
          this.fieldValidationPending = false
        }
      }
    },
    createFieldValidationErrorMap(result) {
      const errorsByField = {}

      for (const message of result?.errors ?? []) {
        if (!message?.field) {
          continue
        }

        if (!errorsByField[message.field]) {
          errorsByField[message.field] = { errors: [], warnings: [] }
        }

        errorsByField[message.field].errors.push(message)
      }

      for (const message of result?.warnings ?? []) {
        if (!message?.field) {
          continue
        }

        if (!errorsByField[message.field]) {
          errorsByField[message.field] = { errors: [], warnings: [] }
        }

        errorsByField[message.field].warnings.push(message)
      }

      return errorsByField
    },
    save() {
      if (this.isEditing) {
        if (this.isEditingExternally) {
          this.$emit('save', this.aeEditableDocument)
        } else if (!this.Aeppic.Model.Recycler.contains(this.aeEditableDocument.id)) {
          this.Aeppic.save(this.aeEditableDocument)
        }
      }
    },
    saveAndStopEditing() {
      this.save()
      this.cancelEditing()
    },
    cancelEditing() {
      if (this.isEditingExternally) {
        this.$emit('cancel', this.aeEditableDocument)
      } else if (this.isEditing) {
        this.stopWatchingDataChanges()
        this.aeEditableDocument = null
      }
    },
    resetEdits() {
      this.startEditing()
    },
    async handleChanges(changedDocument, changes) {
      if (this.isEditing) {
        this.Aeppic.integrate(this.aeEditableDocument, changedDocument)

        await this.loadFormToRender()
      }
    }
  },
}

